import FilesystemColumnHeader from "./FilesystemColumnHeader";
import { useState, useEffect, useRef } from 'react';
import DownIcon from '@material-ui/icons/ArrowDropDown';
import UpIcon from '@material-ui/icons/ArrowDropUp';

import { FilesystemOrder } from './Filesystem.js';




const DEFAULT_COLUMNS = [
  { property:"filesystemName", display:"Name"},
  { property:"lastEditedDate", display:"Edited"},
  { property:"creationDate", display:"Created"}
]

export default function FilesystemHeaderRow({
  columnMinWidths,
  onColumnSizeChange, 
  setSortBy, 
  sortBy ,
  columns=FilesystemOrder,
}){

  return (
    <div class="sg-row" style={{
      background:'#eee',
      border:'1px solid #ccc'
      }}>


     


      {columns.map((col,iiCol) => {
        //let { property, display } = col;
        return <FilesystemColumnHeader {...{
          perscribedWidth:columnMinWidths[col.property],
          sortBy,
          setSortBy,
          iiCol,
          col,
          onColumnSizeChange
        }}/>
      })}
    </div>
  )



}
